// extracted by mini-css-extract-plugin
module.exports = {"root":"ConnectWhatsAppNumberStrip_root__3BBwe"};